import { memo } from "react";
import { LOADER_SPIN_CLASS, LOADER_SPIN_ON_DARK_CLASS } from "@constants/brand.colors";

interface InlineSpinnerProps {
	size?: number;
	className?: string;
	/** Use on accent/primary buttons or dark backgrounds */
	onDark?: boolean;
}

const InlineSpinner = memo(({ size = 32, className = "", onDark = false }: InlineSpinnerProps) => (
	<span
		className={`${onDark ? LOADER_SPIN_ON_DARK_CLASS : LOADER_SPIN_CLASS} ${className}`.trim()}
		style={{ width: size, height: size, borderWidth: Math.max(2, Math.floor(size * 0.125)) }}
		role="progressbar"
		aria-label="Loading"
	/>
));

InlineSpinner.displayName = "InlineSpinner";

export default InlineSpinner;
